import React from 'react'

// query
import { useQuery } from '@apollo/client'
import { GET_EQUIPMENT_PURCHASE_ORDERS_BY_STATUS } from '../../../../graphql/equipmentPurchaseOrder/equipmentPurchaseOrder.queries'

// components
import Card from '../../../../components/cards/Card/Card.component'
import CardListItem from '../../../../components/cards/CardListItem/CardListItem.component'

// icons
import { FontAwesomeIcon  } from '@fortawesome/react-fontawesome'
import { faStore } from '@fortawesome/free-solid-svg-icons'

export default function InventoryPurchaseOrders({ status }) {

    let list = []

    const { loading, error, data } = useQuery(GET_EQUIPMENT_PURCHASE_ORDERS_BY_STATUS, {
        variables: { status }
    })

    if(data && data.equipmentPurchaseOrdersByStatus) {
        list = [...data.equipmentPurchaseOrdersByStatus]
    }

    return (<Card header={{ icon: <FontAwesomeIcon icon={faStore} size='2x' color='#707070' />, title: "Purchase Orders", linkPath: '/inventory/purchase-orders?sortField=datetimeCreated&sortDirection=desc'}}>
        
        {
            list.map(order => {
                return (<CardListItem title={`#${order.number}`} subtitle={order.vendorName} linkText="Details" linkPath={`/inventory/purchase-orders/${order.id}`} />)
            })
        }
    
    </Card>)
}